/**
 * AWS Secret patterns:
 *
 * 1. AWS Access Key ID:
 *    - Starts with specific prefixes (AKIA, AGPA, AIDA, AROA, AIPA, ANPA, ANVA, ASIA, A3T)
 *    - Followed by 16 alphanumeric characters
 *    - Total length: 20 characters
 *
 * 2. AWS Secret Access Key:
 *    - 40 characters long
 *    - Base64 characters: A-Za-z0-9/+=
 *    - Usually appears with assignment patterns like AWS_SECRET_ACCESS_KEY=...
 *
 * 3. AWS Account ID:
 *    - 12 digits, optionally with dashes (format: XXXX-XXXX-XXXX)
 *
 * Examples:
 * - Access Key: `AKIAIOSFODNN7EXAMPLE` (20 chars)
 * - Secret Key: `wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY` (40 chars)
 * - Account ID: `1234-5678-9012` or `123456789012`
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-aws/src/index.ts
 * - https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html
 * - https://docs.cribl.io/docs/regexesyml
 */

const AWS = '(?:AWS|aws|Aws)?_?';
const QUOTE = `["']?`;
const CONNECT = '\\s*(?::|=>|=)\\s*';

export const awsAccessKeyId =
  /\b(A3T[A-Z0-9]|AKIA|AGPA|AIDA|AROA|AIPA|ANPA|ANVA|ASIA)[A-Z0-9]{16}\b/;

export const awsSecretAccessKey = new RegExp(
  String.raw`${QUOTE}${AWS}(?:SECRET|secret|Secret)_?(?:ACCESS|access|Access)_?(?:KEY|key|Key)${QUOTE}${CONNECT}${QUOTE}([A-Za-z0-9/\+=]{40})${QUOTE}`
);

export const awsAccountId = new RegExp(
  String.raw`${QUOTE}${AWS}(?:ACCOUNT|account|Account)_?(?:ID|id|Id)?${QUOTE}${CONNECT}${QUOTE}([0-9]{4}-?[0-9]{4}-?[0-9]{4})${QUOTE}`
);
